<template>
  <div class="">
    <v-alert v-if="loadFailed" type="error"
      >Не удалось загрузить данные</v-alert
    >
    <div class="white elevation-1 pa-2">
      <v-btn text @click="$router.push({ name: 'UsersNewPage' })"
        >Добавить пользователя</v-btn
      >
    </div>

    <v-data-table
      v-if="!loadFailed"
      :headers="headers"
      :items="$store.state.users.items"
      :hide-default-footer="true"
      :disable-pagination="true"
      disable-sort
      class="white elevation-1 mt-2"
      @click:row="pickItem"
    ></v-data-table>
  </div>
</template>

<script>
import { errorMessage } from "@/utils";
export default {
  name: "UsersPage",
  data() {
    return {
      headers: [
        { text: "#", value: "id", sortable: false },
        { text: "Имя", value: "name", sortable: false },
        { text: "Роль", value: "role", sortable: false }
      ],
      loadFailed: false,
      loading: false
    };
  },
  beforeMount() {
    this.fetchData();
  },
  methods: {
    pickItem(item) {
      this.$router.push({ name: "UsersEditPage", params: { id: item.id } });
    },
    async fetchData() {
      this.loading = true;
      this.loadFailed = false;
      try {
        await this.$store.dispatch("getUsers");
      } catch (e) {
        this.loadFailed = true;
        this.$store.dispatch("addMessage", {
          text: errorMessage(e),
          type: "error"
        });
      }
      this.loading = false;
    }
  }
};
</script>

<style>
table tr td {
  cursor: pointer !important;
}
</style>
